import '@babylonjs/inspector';
import { ViewerEvents, BaseExtension } from '@immersive-tech/viewer-engine';

import type { Viewer } from '@immersive-tech/viewer-engine';

export class Debugger extends BaseExtension {
  constructor(viewer: Viewer) {
    super(viewer);

    this.viewer.addEventListener(ViewerEvents.VIEWER_INITIALIZED, this.viewerInitializeEventHandler.bind(this));
  }

  viewerInitializeEventHandler() {
    window.addEventListener('keyup', (event: KeyboardEvent) => {
      if (!this.viewer.scene) return;

      if (event.code === 'Backquote') {
        const isVisible = this.viewer.scene.debugLayer.isVisible();

        if (isVisible) {
          this.viewer.scene.debugLayer.hide();
        } else {
          this.viewer.scene.debugLayer.show();
        }
      }
    });
  }
}
